import React from 'react';
import css from 'styled-jsx/css';
import SliderSimilarMobile from '../SimilarSlideMobile';
import RelatedSimilarSlide from '../RelatedSimilarSlide';

import withI18next from '~/../hocs/_withI18next';
import I18nLink from '~/components/I18nLink';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import themeVariables from '~/shared/themeVariables';

const OtherImagesNew = ({ t, title, collection, href, as, loading, type }) => {
  if (loading) {
    return (
      <section className="other-images">
        <h3
          className="service-title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <LoadingSpinner />
        <style jsx>{styles}</style>
      </section>
    );
  }

  if (!collection || collection.length === 0) {
    return null;
  }

  return (
    <section className="other-images">
      <div className="header-service">
        <h3
          className="service-title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {as && href && (
          <I18nLink as={as} href={href}>
            <a className="link-to">{t('view_all')}</a>
          </I18nLink>
        )}
      </div>
      {type !== 'related' && (
        <>
          <div className="similar-data desktop">
            <SliderSimilarMobile images={collection} isMain />
          </div>
          <div className="similar-data mobile">
            <SliderSimilarMobile images={collection} isMain />
          </div>
        </>
      )}
      {type === 'related' && (
        <>
          <div className="similar-data desktop">
            <RelatedSimilarSlide images={collection} isMain />
          </div>
          <div className="similar-data mobile">
            <RelatedSimilarSlide images={collection} isMain />
          </div>
        </>
      )}
      <style jsx>{styles}</style>
    </section>
  );
};

const styles = css`
  .header-service {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    // background: #1b2833;
    // padding: 0 16px;
    border-bottom: 2px solid #1b2833;
  }
  .other-services {
    width: 100%;
  }
  .link-to {
    text-align: center;
    text-decoration-line: none !important;
    font-weight: 700;
  }
  .link-to:hover {
    text-decoration-line: underline !important;
    opacity: 0.8;
  }
  .service-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    color: #1b2833;
    padding: 0;
    margin: 0;
    flex: 6;
    line-height: 1.4;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  .other-service-images {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  .other-images {
    display: flex;
    flex-direction: column;
  }

  .btn-see-more {
    font-size: ${themeVariables.fontSize.medium}px;
    padding: ${themeVariables.space.half}px ${themeVariables.space.medium}px;
    align-self: center;
    margin-top: ${themeVariables.space.half}px;
  }
  .similar-data.mobile {
    display: none;
  }
  @media (max-width: ${themeVariables.breakpoints.tabletS.maxWidth}px) {
    .header-service {
      border-radius: 0;
    }
    .similar-data.desktop {
      display: none;
    }
    .similar-data.mobile {
      display: block;
    }
    .header-service {
      border-radius: 0;
      padding: 0 8px;
    }
    .service-title {
      max-width: 400px;
      line-height: 1.4;
    }
  }
  @media only screen and (max-width: ${themeVariables.breakpoints.mobile
      .maxWidth}px) {
    .header-service {
      border-radius: 0;
      padding: 0 8px;
    }
    .service-title {
      line-height: 1.4;
    }
  }
`;

export default withI18next()(OtherImagesNew);
